<template>
    <b-container class="byc-container byc-font-size">
        <b-row>
            <b-col class="text-right mt-3">
                <a :class="[isJACareerEntrepreApp ? 'skip-green-dark' : 'skip-green-light']" class="skip-link" @click="skip()" tabindex="0" role="button">Skip</a>
            </b-col>
        </b-row>
        <b-row>
            <b-col tabindex="0"  class="title" cols="12">Before you continue...</b-col>
            <b-col tabindex="0"  class="sub-title" cols="12">Lets review where you left off.</b-col>
        </b-row>

        <Carousel @done="skip">
            <CarouselItem>
                <div class="project-status-item">
                    <project-status
                            :index="$route.params.index"
                            :project="project"
                            :show-actions="false"
                    />
                </div>
                <b-col cols="12" class="divider">
                    <hr>
                </b-col>
                <div class="project-carousel-item">
                    <b-col cols="12" class="section-title">
                        {{getMessage(2, 'empathy-map-title')}}<span class="sr-only">.</span>
                    </b-col>
                    <question v-if="project['problem']"
                              :label="getMessage(1, 'project-problem')">
                        <span v-if="isJACareerEntrepreApp">{{ printTextOrBlank(project['problem']) }}</span>
                        <span v-else>{{ getMessage(1, 'project-problem-placeholder') }}</span>
                    </question>
                    <question v-if="project['customer']"
                              :label="getMessage(1, 'project-customer')">
                        <span v-if="isJACareerEntrepreApp">{{ printTextOrBlank(project['customer']) }}</span>
                        <span v-else>{{ getMessage(1, 'project-customer-placeholder') }}</span>
                    </question>

                </div>
            </CarouselItem>
            <CarouselItem v-if="project.forms[Steps.FORM_SKETCH] ">
                <div class="project-carousel-item">
                    <question :label="getMessage(4, 'sketch')">
                        <img class="sketch-image"
                             v-if="image"
                             :src="image" alt="Sketch">
                        <span v-else>blank</span>
                    </question>
                    <question v-if="project.forms[Steps.FORM_SKETCH]"
                              :label="getMessage(4, 'empathy-map-sub')">

                        <item :label="getMessage(4, 'firstThing')"
                              :text="project.forms[Steps.FORM_SKETCH].firstThing"/>

                        <item :label="getMessage(4, 'secondThing')"
                              :text="project.forms[Steps.FORM_SKETCH].secondThing"/>
                        <item :label="getMessage(4, 'thirdThing')"
                              :text="project.forms[Steps.FORM_SKETCH].thirdThing"/>

                    </question>

                </div>
            </CarouselItem>
            <CarouselItem v-if="project.forms[Steps.FORM_CUSTOMER_PROBLEM] || project.forms[Steps.FORM_EMOTION]">
                <div class="project-carousel-item">
                    <question v-if="project.forms[Steps.FORM_EMOTION]"
                              :label="getMessage(5, 'empathy-map-sub')">
                        <item :label="getMessage(5, 'emotion')"
                              :text="project.forms[Steps.FORM_EMOTION].emotion.value"/>
                        <item :label="getMessage(5, 'otherEmotion')"
                              :text="project.forms[Steps.FORM_EMOTION].otherEmotion"/>
                    </question>
                    <question v-if="project.forms[Steps.FORM_CUSTOMER_PROBLEM]"
                              :label="getMessage(6, 'empathy-map-sub')">
                        <item :label="getMessage(6, 'iam')"
                              :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].iam"/>
                        <item :label="getMessage(6, 'tryingto')"
                              :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].tryingto"/>
                        <item :label="getMessage(6, 'but')"
                              :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].but"/>
                        <item :label="getMessage(6, 'because')"
                              :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].because"/>
                        <item :label="getMessage(6, 'emotions')"
                              :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].emotions"/>
                    </question>
                </div>
            </CarouselItem>
            <CarouselItem v-if="project.forms[Steps.FORM_IDEAL_STATE] ">
                <div class="project-carousel-item">
                    <question v-if="project.forms[Steps.FORM_IDEAL_STATE]"
                              :label="getMessage(6, 'empathy-map-sub')">
                        <item :label="getMessage(6, 'perfectWorld')"
                              :text="project.forms[Steps.FORM_IDEAL_STATE].perfectWorld"/>
                        <item :label="getMessage(6, 'benefit')"
                              :text="project.forms[Steps.FORM_IDEAL_STATE].benefit"/>
                        <item :label="getMessage(6, 'emotions')"
                              :text="project.forms[Steps.FORM_IDEAL_STATE].emotions"/>
                    </question>
                </div>
            </CarouselItem>
            <CarouselItem
                    v-if="project.forms[ Steps.FORM_BRAINSTORMING] || project.forms[ Steps.FORM_TOP_IDEAS] || project.forms[ Steps.FORM_CAREER]">
                <div class="project-carousel-item">
                    <b-col cols="12" class="mt-3 section-title">
                        {{getMessage(8, 'gobroadtogonarrow-title')}}<span class="sr-only">.</span>
                    </b-col>
                    <question v-if="project.forms[ Steps.FORM_BRAINSTORMING]"
                              :label="getMessage(10, 'gobroadtogonarrow-sub')">
                        <item :label="getMessage(10, 'who')"
                              :text="project.forms[Steps.FORM_BRAINSTORMING].who"/>
                        <item :label="getMessage(10, 'rounds')"
                              :text="project.forms[Steps.FORM_BRAINSTORMING].rounds"/>
                        <item :label="getMessage(10, 'ideas')"
                              :text="project.forms[Steps.FORM_BRAINSTORMING].ideas"/>
                    </question>
                    <question v-if="project.forms[ Steps.FORM_TOP_IDEAS]"
                              :label="getMessage(12, 'gobroadtogonarrow-sub')">
                        <item :label="getMessage(12, 'firstIdea')"
                              :text="project.forms[Steps.FORM_TOP_IDEAS].firstIdea"/>
                        <item :label="getMessage(12, 'secondIdea')"
                              :text="project.forms[Steps.FORM_TOP_IDEAS].secondIdea"/>
                        <item :label="getMessage(12, 'thirdIdea')"
                              :text="project.forms[Steps.FORM_TOP_IDEAS].thirdIdea"/>
                    </question>
                    <question v-if="project.forms[ Steps.FORM_CAREER] && careers"
                              :label="getMessage(13, 'gobroadtogonarrow-sub')">
                        <item :label="getMessage(13, 'careersTextSelected')"
                              :text="careers"/>
                    </question>
                </div>
            </CarouselItem>
            <CarouselItem v-if="project.forms[Steps.FORM_INTERVIEW_RESULTS]">
                <div class="project-carousel-item">
                    <b-col cols="12" class="mt-3 section-title">
                        {{getMessage(14, 'rapidexperiment-title')}}<span class="sr-only">.</span>
                    </b-col>
                    <question v-if="project.forms[Steps.FORM_INTERVIEW_RESULTS]"
                              :label="getMessage(18, 'rapidexperiment-sub')">
                        <item :label="getMessage(18, 'interview')"
                              :text="project.forms[Steps.FORM_INTERVIEW_RESULTS].interview"/>
                        <item :label="getMessage(18, 'find')"
                              :text="project.forms[Steps.FORM_INTERVIEW_RESULTS].find"/>
                        <item :label="getMessage(18, 'mostappealing')"
                              :text="project.forms[Steps.FORM_INTERVIEW_RESULTS].mostappealing"/>
                        <item :label="getMessage(18, 'leastappealing')"
                              :text="project.forms[Steps.FORM_INTERVIEW_RESULTS].leastappealing"/>
                    </question>
                </div>
            </CarouselItem>
            <CarouselItem v-if="project.forms[Steps.FORM_EXPERIENCE_RESULTS]">
                <div class="project-carousel-item">
                    <question v-if="project.forms[Steps.FORM_EXPERIENCE_RESULTS]"
                              :label="getMessage(22, 'rapidexperiment-sub')">
                        <item :label="getMessage(22, 'interview')"
                              :text="project.forms[Steps.FORM_EXPERIENCE_RESULTS].interview"/>
                        <item :label="getMessage(22, 'jobplace')"
                              :text="project.forms[Steps.FORM_EXPERIENCE_RESULTS].jobplace"/>
                        <item :label="getMessage(22, 'jobtitle')"
                              :text="project.forms[Steps.FORM_EXPERIENCE_RESULTS].jobtitle"/>
                        <item :label="getMessage(22, 'findcareer')"
                              :text="project.forms[Steps.FORM_EXPERIENCE_RESULTS].findcareer"/>
                        <item :label="getMessage(22, 'mostappealing')"
                              :text="project.forms[Steps.FORM_EXPERIENCE_RESULTS].mostappealing"/>
                        <item :label="getMessage(22, 'leastappealing')"
                              :text="project.forms[Steps.FORM_EXPERIENCE_RESULTS].leastappealing"/>
                    </question>
                </div>
            </CarouselItem>
        </Carousel>
    </b-container>
</template>

<script>

    import ProjectYouContinue from "../../../core/Mixins/ProjectYouContinue";
    import {Steps} from "../Utils";

    export default {
        name: "JsBeforeYouContinue",
        mixins: [ProjectYouContinue],
        created() {
            this.Steps = Steps
        },
        computed: {
            careers() {
                const careers = this.project.forms[Steps.FORM_CAREER].careersTextSelected

                if (!careers.length) {
                    return null
                }

                const dataCareers = careers.map(c => {
                    return c.value
                })
                return dataCareers.join(', ')
            },
        },
        methods: {
            skip() {
                let redirection = 'js_deep_customer_empathy_2'
                if (this.project.lastStep >= 4) {
                    const nextStep = this.project.lastStep + 1
                    switch (nextStep) {
                        case 5:
                        case 6:
                        case 7:
                            redirection = `js_deep_customer_empathy_${nextStep}`
                            break
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                            redirection = `js_go_broad_to_go_narrow_${nextStep}`
                            break
                        case 14:
                        case 15:
                        case 16:
                        case 17:
                        case 18:
                        case 19:
                        case 20:
                        case 21:
                        case 22:
                            redirection = `js_rapid_experiments_with_customers_${nextStep}`
                            break
                    }
                }
                const index = this.$route.params.index
                this.$router.push({name: redirection, params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"

    .container
        max-width 65%;
        margin-top 0px !important
        &-cover
            display block
            margin-top 0

    .byc-container
        background-color color-1
        padding 15px 10px
        min-height 100vh
        max-height 100vh
        overflow hidden
        min-width 45vh

    .skip-link
        padding-right 19px
        font font-poppins-semibold
        font-size 16px
        letter-spacing 0.8px
        cursor pointer

        &.skip-green-light
            color color-5
            &:hover
                color color-5

        &.skip-green-dark
            color color-green-light
            &:hover
                color color-green-dark

    .title
        padding 0 29px
        font font-poppins-semibold
        letter-spacing 0.53px
        font-size 21px
        color black

    .sub-title
        padding 0 29px
        font font-sourcesans-regular
        font-size 16px
        color color-4

    .content
        background-color white

    .divider
        padding-left 0
        padding-right 0

        hr
            color black
            margin-top 0

    .section-title
        font font-poppins-bold
        font-size 16px
        color black
        letter-spacing 0.4px

    .sketch-image
        max-width: 50%
        max-height: 50vh

    .project-status-item
        border 0
        box-shadow none
        margin-bottom 0
        padding 0 25px

    .project-carousel-item
        padding 0 10px

</style>
